import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid/main';

@Component({
  selector: 'lfwms-view-balances-cell-renderer',
  templateUrl: './view-balances-cell-renderer.component.html',
  styleUrls: ['./view-balances-cell-renderer.component.css']
})
export class ViewBalancesCellRendererComponent implements ICellRendererAngularComp {

  public params: any;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  public refresh(): boolean {
    return true;
  }

}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component.ts